import api from "pages/api/api";

export async function abrirRelatorio(url) {
  if (!url) return;

  try {
    const destino = new URL(url, window.location.origin);

    // Nunca enviar o JWT para domínios externos.
    if (
      destino.origin !== window.location.origin ||
      !destino.pathname.startsWith("/api/Relatorios/OpenTemp/")
    ) {
      throw new Error("URL do relatório não permitido.");
    }

    const resp = await api.get(destino.href, {
      responseType: "blob",
    });

    const blob = new Blob([resp.data], {
      type: resp.headers["content-type"] || "application/pdf",
    });

    const blobUrl = URL.createObjectURL(blob);

    const isIOS =
      /iPad|iPhone|iPod/.test(window.navigator.userAgent) ||
      (window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1);

    if (isIOS) {
      window.location.href = blobUrl;
    } else {
      const janela = window.open(blobUrl, "_blank", "noopener,noreferrer");

      if (!janela) {
        window.location.href = blobUrl;
      }
    }

    // Libertar o URL temporário após a abertura.
    setTimeout(() => URL.revokeObjectURL(blobUrl), 300000);
  } catch (err) {
    console.error("Erro ao abrir relatório:", err);
    window.alert("Não foi possível abrir o relatório.");
  }
}
